import React from 'react';
import './Home.css';
import About from '../About/About';


const Home = () => {
    return (
        <div>
            <About />
        </div>
    );
};

export default Home;